import nlBeeld from "@/assets/versiebeeld/CampagneBeeld_Nl.png";
import enBeeld from "@/assets/versiebeeld/CampagneBeeld_En.png";

export default {
    data() {
        return {
            isDutch: navigator.language.startsWith('nl'),
            versieNummer:"1.0.4"
        }
    },
    computed:{
        campagneBeeld(){
            return this.isDutch ? nlBeeld : enBeeld
        }
    },
    methods: {
        getVersieTitel(){
                return this.getVertaling('Versie') + " " + this.versieNummer
        },
        getVersieDatum(){
            return this.isDutch ? "September 2026" : "September 2026"
        },
        getRegelEen(){
            return this.isDutch ? "Applicatie voor het loggen van waarnemingen" : "Application for logging observations"
        },
        getRegelTwee(){
            return this.isDutch ? "Voor gebruik van de applicatie kan je het helpbestand openen rechtsboven met het icoon:"
                : "To use the application, you can open the help file at the top right with the icon:"
        },
        getCheckboxText(){
            return this.isDutch ? "Niet meer tonen" : "Don't show again"
        },
        getSluitBoodschap(){
            return this.isDutch ? "Melding Sluiten" : "Close notification"
        },

         // Opmerking bij verbeterde versie
        getAanpassing(){
            // return this.isDutch ? " "
            //     : " "
            return this.isDutch ? "Kleuren app aangepast, conform met de VVS website"
                : "App colors updated to match the VVS website"
        },
    }
}